export default "__VITE_ASSET__BdehzA4t__"